import { render, staticRenderFns } from "./TransmittersNewTransmitter.vue?vue&type=template&id=3a0159fb"
import script from "./TransmittersNewTransmitter.vue?vue&type=script&lang=js"
export * from "./TransmittersNewTransmitter.vue?vue&type=script&lang=js"
import style0 from "./TransmittersNewTransmitter.vue?vue&type=style&index=0&id=3a0159fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports